const PLAN_MAP = {
  enterprise_plan: "ENTERPRISE",
  "Enterprise Plan": "ENTERPRISE",
  enterprise: "ENTERPRISE",
  business_plan: "BUSINESS",
  "Business Plan": "BUSINESS",
  business: "BUSINESS",
  professional_plan: "PROFESSIONAL",
  "Professional Plan": "PROFESSIONAL",
  professional: "PROFESSIONAL",
  starter_plan: "STARTER",
  "Starter Plan": "STARTER",
  starter: "STARTER",
  free: "STARTER",
  free_plan: "STARTER",
};

export const PLAN_LEVELS = {
  STARTER: 1,
  PROFESSIONAL: 2,
  BUSINESS: 3,
  ENTERPRISE: 4,
};

export const FEATURE_ACCESS = {
  basicCRM: "STARTER",
  gpsTracking: "STARTER",
  clientCreation: "STARTER",
  expenses: "STARTER",

  interactiveMaps: "PROFESSIONAL",
  pincodeFiltering: "PROFESSIONAL",
  quickVisits: "PROFESSIONAL",

  advancedCRM: "BUSINESS",
  advancedSearch: "BUSINESS",
  analytics: "BUSINESS",
  services: "BUSINESS",
  tallySync: "BUSINESS",

  customReports: "ENTERPRISE",
  dataExport: "ENTERPRISE",
  activityNotifications: "ENTERPRISE",
  apiAccess: "ENTERPRISE",
  bulkOperations: "ENTERPRISE",
  whiteLabel: "ENTERPRISE",
};

export function normalizePlan(plan) {
  if (!plan) return null;
  const normalized = PLAN_MAP[plan] || plan.toUpperCase().trim();
  return PLAN_LEVELS[normalized] ? normalized : null;
}

export function isFeatureEnabled(currentPlan, feature) {
  const normalizedPlan = normalizePlan(currentPlan);

  if (!normalizedPlan) {
    console.warn("Invalid plan:", currentPlan);
    return false;
  }

  if (!FEATURE_ACCESS[feature]) {
    console.warn("Invalid feature:", feature);
    return false;
  }

  const currentLevel = PLAN_LEVELS[normalizedPlan];
  const requiredLevel = PLAN_LEVELS[FEATURE_ACCESS[feature]];

  return currentLevel >= requiredLevel;
}

export function isCurrentPlan(userPlan, targetPlan) {
  const normalized = normalizePlan(userPlan);
  const target = normalizePlan(targetPlan);
  return normalized === target;
}

export function canUpgrade(userPlan, targetPlan) {
  const current = PLAN_LEVELS[normalizePlan(userPlan)];
  const target = PLAN_LEVELS[normalizePlan(targetPlan)];
  return target > current;
}

export function getPlanDisplayName(plan) {
  const normalized = normalizePlan(plan);
  const displayNames = {
    STARTER: "Starter",
    PROFESSIONAL: "Professional",
    BUSINESS: "Business",
    ENTERPRISE: "Enterprise",
  };
  return displayNames[normalized] || plan || "Unknown";
}

export function getPlanLevel(plan) {
  return PLAN_LEVELS[normalizePlan(plan)] || 0;
}

export function getPlanFeatures(plan) {
  const normalizedPlan = normalizePlan(plan);
  if (!normalizedPlan) return {};

  const features = {};
  for (const [feature, requiredPlan] of Object.entries(FEATURE_ACCESS)) {
    features[feature] = PLAN_LEVELS[normalizedPlan] >= PLAN_LEVELS[requiredPlan];
  }
  return features;
}

export function isPlanExpired(license) {
  if (!license?.expiresAt) return false;
  return new Date(license.expiresAt) < new Date();
}

export function isPlanExpiringSoon(license, daysThreshold = 30) {
  if (!license?.expiresAt) return false;
  const expiryDate = new Date(license.expiresAt);
  const now = new Date();
  const daysUntilExpiry = Math.ceil((expiryDate - now) / (1000 * 60 * 60 * 24));
  return daysUntilExpiry > 0 && daysUntilExpiry <= daysThreshold;
}